module.exports = __webpack_public_path__ + "static/astral_dreadnought-5c05bf2e96f91548c09fa0f7d6ef9917.png";